export default "__VITE_PUBLIC_ASSET__68cf7676__"